import React, { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PostsGridContent } from '../PostsGridContent/PostsGridContent';
import { usePostCollection } from '../usePostCollection';
import { PER_PAGE } from './constants';
import { BoostedPostsGridProps } from './types';

export const BoostedPostsGrid: FC<BoostedPostsGridProps> = ({ postId, ...props }) => {
    const [query] = useSearchParams();

    const collection = usePostCollection({
        namespace: `boost-collection-${postId}`,
        filters: {
            amount: PER_PAGE,
            push_payload: query.get('push_payload'),
            first_post_id: query.get('first_post_id'),
            no_log: query.get('no_log'),
            query: '',
        },
        forceFiltersUpdate: true,
    });

    return <PostsGridContent collection={collection} keyPrefix={`boost-${postId}`} {...props} />;
};
